import { Button as StandaloneButton } from '@/components/Button';
import { FollowAuthorTheme } from '@/components/FollowAuthor/theme';
import { GenericSlot, GenericSlotFactory } from 'base/components/GenericSlot';

const $ = GenericSlotFactory({ theme: FollowAuthorTheme });

const Base = $({ as: 'div', slot: 'base' });
const Modal = $({ as: 'dialog', slot: 'modal' });
const Group = $({ as: 'div', slot: 'group' });
const Headline = $({ as: 'h3', slot: 'headline' });
const Content = $({ as: 'div', slot: 'content' });
const CloseButton = $({ as: 'button', slot: 'closeButton' });
const ModalButton = GenericSlot({ as: StandaloneButton, theme: FollowAuthorTheme.ModalButton });
const Button = GenericSlot({ as: StandaloneButton, theme: FollowAuthorTheme.Button });

export const FollowAuthor = Object.assign(Base, {
  Modal,
  Group,
  Headline,
  Content,
  CloseButton,
  Button,
  ModalButton,
});
